import styled from "styled-components";

export const TechnicianRankingStyles = styled.div`
  display: flex;
  flex-direction: column;

  .rank-head,
  .rank-row {
    display: grid;
    grid-template-columns: 36px 1.7fr 1.5fr 1fr 0.7fr;
    align-items: center;
    gap: 12px;
    padding: 10px 20px;
  }

  .rank-head {
    background: ${({ theme }) => theme.colors.accent[50]};
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-size: 11px;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    border-top: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
  }

  .rank-head .sortable {
    cursor: pointer;
    user-select: none;
    transition: color 0.12s;
  }
  .rank-head .sortable:hover {
    color: ${({ theme }) => theme.colors.accent[500]};
  }
  .rank-head .sortable.is-active {
    color: ${({ theme }) => theme.colors.accent[500]};
  }
  .rank-head .sortable.is-active::after {
    content: " ↓";
  }

  .rank-row {
    border-bottom: 1px solid ${({ theme }) => theme.colors.semantic.separator};
    transition: background 0.12s;
  }
  .rank-row:hover {
    background: ${({ theme }) => theme.colors.accent[50]};
  }
  .rank-row:last-child {
    border-bottom: none;
  }

  .rank-pos {
    font-size: 12px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-variant-numeric: tabular-nums;
  }

  .rank-tech {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .rank-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 12px;
  }

  .rank-name {
    font-size: 13px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.semantic.text.strong};
  }

  .rank-meta {
    font-size: 11px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    margin-top: 1px;
  }

  .rank-bar-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .rank-bar-track {
    flex: 1;
    height: 6px;
    background: ${({ theme }) => theme.colors.accent[50]};
    border-radius: 999px;
    overflow: hidden;
  }
  .rank-bar-fill {
    height: 100%;
    background: ${({ theme }) => theme.colors.accent[500]};
    border-radius: 999px;
  }
  .rank-num {
    font-size: 12px;
    font-weight: 600;
    min-width: 28px;
    text-align: right;
    font-variant-numeric: tabular-nums;
  }

  .rank-rating {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .rank-rating-val {
    font-weight: 600;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
  }

  .rank-reviews {
    font-size: 13px;
    color: ${({ theme }) => theme.colors.semantic.text.weak};
    font-variant-numeric: tabular-nums;
  }
`;
